import { useEffect } from 'react';
import { destroyGantt } from '../utils';

export const useDestroyGanttOnUnmount = (ganttName) => {
  useEffect(() => () => destroyGantt(ganttName), []);
};
